import React from 'react';
import Asset from '../../requests/apa/Asset';
import Utils from "../../utils/Utils";
import logger from 'src/utils/logger/logger';

function focusHandler(focusHandlerCallBack, data) {
  if (window.setResumeData) window.setResumeData(data);
  return typeof focusHandlerCallBack === 'function' ? focusHandlerCallBack(data) : null;
}

function keyUpHandler(keyUpHandlerCallBack, props) {
  return typeof keyUpHandlerCallBack === 'function' ? keyUpHandlerCallBack(props) : null;
}

function keyDownHandler(e, keyDownHandlerCallBack, params) {
  return typeof keyDownHandlerCallBack === 'function' ? keyDownHandlerCallBack(e, params) : null;
}

function createBadge(badge, extraSpace = false) {
  if (badge === '') return '';
  const badgeClassName = `box-badge-styles ${extraSpace ? 'extra-space' : ''}`;
  return <div className={badgeClassName} dangerouslySetInnerHTML={{ __html: badge }}></div>;
}

function getPlaceholder(type) {
  let placeholder = null;

  switch (type) {
    case 'highlight':
      placeholder = Asset.get(
        'asset_placeholder_highlight',
        '/images/placeholder_highlight.png'
      );
      break;
    case 'landscape':
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
      break;
    case 'portrait':
      placeholder = Asset.get(
        'asset_placeholder_portrait',
        '/images/placeholder_portrait.png'
      );
      break;
    case 'user-profile':
    case 'user-info':
      placeholder = Asset.get(
        'placeholder_talent_movie',
        '/images/placeholder_talent_movie.png'
      );
      break;
    case 'cd':
    case 'square':
    case 'circle':
      placeholder = Asset.get('asset_placeholder_square', '/images/placeholder_square.png');
      break;
    case 'actor':
    case 'casting':
    case 'costume designer':
    case 'original music':
    case 'production design':
    case 'screenwriter':
    case 'set decoration':
    case 'art director':
    case 'supervising art direction':
    case 'executive producer':
    case 'film editor':
    case 'cinematographer':
    case 'producer':
    case 'talent':
    case 'narrator':
    case 'voice':
    case 'director':
    case 'writer':
    case 'conductor':
      placeholder = Asset.get(
        'content_data_talent_placeholder',
        '/images/content_data_talent_placeholder.png'
      );
      break;
    default:
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
  }

  return placeholder;
}

function getUri(href, group_id, data, ignoreSeenLast) {
  href = data.href || data.src || `/vcard/${group_id || ''}`;
  if (data.live_enabled == '1') href = `/player/${group_id}`;
  if (href.indexOf('/vcard/') !== -1) href = `${href}${ignoreSeenLast ? '/1' : ''}`;
  return href;
}

function createSibling(sibling) {
  if (!sibling) return null;
  const placeholderStyle = { backgroundImage: `url(${this.getPlaceholder('portrait')})` };
  return (
    <div className="placeholder-container">
      <div className="sibling-wrapper">
        <div
          className="card-placeholder"
          style={placeholderStyle}
          alt="placeholder"
        />
        <img className="card-cover" src={sibling} />
      </div>
      <div className="arrow-right" />
    </div>
  );
}

function createTitle(title, showTitle, isChannel = false) {
  const titleComponent = <div className="card-title">
    <span className="title-bottom">{title}</span>
  </div>;

  const shouldShowTitle = !isChannel && title && title.length > 0 && showTitle;
  return shouldShowTitle ? titleComponent : null;
}

function createSubTitle(subTitle) {
  const titleComponent = <div className="card-subtitle">
    <span className="subtitle-bottom">{subTitle}</span>
  </div>;

  return subTitle.length ? titleComponent : null;
}

function createLabel(label) {
  const span = <div className="card-label"
    dangerouslySetInnerHTML={{ __html: label }} />;

  return label.length ? span : null;
}

function posterTitleIsEnabled(provider = 'default', display = 'landscape') {

  if(typeof provider !== 'string') return false;

  provider = provider.toLowerCase().split(' ').join('');
  let poster_title_configuration = Utils.getAPARegionalized('poster_title_configuration', provider, {
    "default": { "portrait": true, "landscape": true },
    "amco": { "portrait": false, "landscape": false },
    "fox": { "portrait": true, "landscape": true },
    "hbo": { "portrait": true, "landscape": true },
    "noggin": { "portrait": true, "landscape": true },
    "picardia": { "portrait": true, "landscape": true },
    "edye": { "portrait": true, "landscape": true },
    "paramount": { "portrait": true, "landscape": true },
    "stingrayqello": { "portrait": true, "landscape": true },
    "stingraykaraoke": { "portrait": true, "landscape": true },
    "atresplayer": { "portrait": true, "landscape": true }
  });
  if (poster_title_configuration[display]) {
    return poster_title_configuration[display];
  }
  poster_title_configuration = poster_title_configuration[provider] ? poster_title_configuration[provider] : poster_title_configuration['default'];
  return poster_title_configuration && poster_title_configuration[display] ? poster_title_configuration[display] : false;
}

function createPlayerIcon() {
  return (
    <div className={'player-icon'}>
      <img src={Asset.get('content_playing_option_button_play', '')} alt="player icon" />
    </div>
  );
}

function createProgressBarLastChannelViewed(bookmark, progressbarbackcolor, progressbarcolorprogress) {
const widthStyle = bookmark && Number(bookmark) >= 0 && Number(bookmark) <= 100 ? { width: `${bookmark}%` } : {}
const backgroundColorStyle = {backgroundColor: `${progressbarcolorprogress}`}
const finallyStyle = { ...widthStyle, ...backgroundColorStyle };

  if (bookmark && bookmark !== '0') {
    return (
      <div>
        {bookmark && bookmark !== '0' && (
          <div className={`progress-bar-container-card`} style={{backgroundColor: `${progressbarbackcolor}`}}>
            <div className="progress-bar" style={finallyStyle}></div>
          </div>
        )}
      </div>
    );
  }
}

function createProgressBar(bookmark, hasPlayerIcon) {
  if (!bookmark || bookmark === '0') return null;

  const bookmarkNum = Number(bookmark);
  const barStyle = bookmarkNum >= 0 && bookmarkNum <= 100 ? { width: bookmark + '%' } : {};
  const containerClassName = `progress-bar-container-card ${hasPlayerIcon ? 'reduce-bar' : ''}`;
  const progressBar = (
    <div className={containerClassName}>
      <div className="progress-bar" style={barStyle}></div>
    </div>
  );

  if (hasPlayerIcon) {
    return (
      <div>
        {progressBar}
        {createPlayerIcon()}
      </div>
    );
  }

  return progressBar;
}

function createDeleteIcon() {
  return (
    <span className={'delete-action-icon'}>
        <span className="color-ball red" />
        <i className="fa fa-trash-o" />
      </span>
  );
}

function createFooter(showTrashButton, showActions, isTitleEnable = false) {
  if (!showTrashButton || !showActions) return null;
  const footerClassName = `footer-actions ${isTitleEnable ? 'fix-top-icon' : ''}`;
  return (
    <div className="card-title">
      <span className={footerClassName}>
        {createDeleteIcon()}
      </span>
    </div>
  );
}

function fillZeroLeft(num, size) {
  if (!num) return '';
  num = num.toString();
  while (num.length < size) num = "0" + num;

  return num;
}

function getTimeProgress(startUnixtime, endUnixtime) {
  let justNow = Utils.nowAsTimestampSeconds();
  let progress = 0;
  // logger.debug('PGRESS ', justNow, startUnixtime, endUnixtime);
  if (startUnixtime <= justNow && endUnixtime > justNow) {
    const duration = endUnixtime - startUnixtime;
    let limit_forward = endUnixtime - justNow;
    let dur_limit_forward = endUnixtime - startUnixtime - limit_forward;
    const percent = dur_limit_forward > 0 ? (dur_limit_forward * 100) / duration : 0;
    progress =  percent <= 100 ? percent : 100;
  }
  // logger.debug('PGRESS: ', progress, '%');

  return progress;
}

const getDataSnUpAndDown = (idsRibbonsUpAndDown, ribbonIndex, focusUpDefault, focusDownDefault) => {
  const haveIdsRibbonsUpAndDown = idsRibbonsUpAndDown && Object.keys(idsRibbonsUpAndDown).length > 0;
  const haveRibbonIndex = ribbonIndex !== undefined || ribbonIndex !== null;

  if(haveIdsRibbonsUpAndDown && haveRibbonIndex) {
    const { focusUp, focusDown} = idsRibbonsUpAndDown[ribbonIndex] || {};
    return { focusUp, focusDown}
  }

  return { focusUp: focusUpDefault, focusDown: focusDownDefault };
}


export default {
  getPlaceholder,
  getUri,

  createSibling,
  createTitle,
  createLabel,

  focusHandler,
  keyUpHandler,
  keyDownHandler,

  posterTitleIsEnabled,
  createBadge,
  createProgressBar,
  createProgressBarLastChannelViewed,
  createFooter,
  createDeleteIcon,
  fillZeroLeft,
  getTimeProgress,
  createPlayerIcon,
  createSubTitle,
  getDataSnUpAndDown
};



// WEBPACK FOOTER //
// ./src/components/CardNew/helpers.js